import { connect } from 'react-redux';
import { throttle } from 'lodash';
import ResourceTree from 'components/timeline_control/resources/resource_tree';
import TimelineChart from './TimelineChart';
import {
  updateStartEndDate,
  setDates,
  resetDates,
  changeMinDate,
  changeMaxDate,
  changeTimeScale,
  changeZoom,
} from '../../store/actions';

const mapStateToProps = state => {
  const timelineConfig = state.get('timelineConfig');
  const dateRange = state.get('dateRange');
  const timelineData = state.get('timelineData').toJS();
  const resourceTree = new ResourceTree(
    timelineData.data,
    timelineData.timelineType,
    timelineConfig.fontSize
  );

  return {
    timelineConfig,
    resourceTree,
    dateRange,
    dependencyLinks: timelineData.dependencyLinks,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateDates(startDate, endDate) {
      dispatch(updateStartEndDate(startDate, endDate));
    },

    setDates: throttle(dates => dispatch(setDates(dates)), 500),

    resetDates() {
      dispatch(resetDates());
    },

    changeMinDate(date) {
      dispatch(changeMinDate(date));
    },

    changeMaxDate(date) {
      dispatch(changeMaxDate(date));
    },

    changeTimeScale(timescale) {
      dispatch(changeTimeScale(timescale));
    },

    changeZoom(zoom) {
      dispatch(changeZoom(zoom));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TimelineChart);
